import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=629aa382&scoped=true"
import script from "./Primary.vue?vue&type=script&lang=js"
export * from "./Primary.vue?vue&type=script&lang=js"
import style0 from "./Primary.vue?vue&type=style&index=0&id=629aa382&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629aa382",
  null
  
)

export default component.exports